import { getEmptyStyles } from './variantStyles/empty';
import { getEmptyMainSectionStyles } from './variantStyles/emptyMainSection';
import { getIconStyles } from './variantStyles/icon';
import { getIconSelectorStyles } from './variantStyles/iconSelector';
import { getImageStyles } from './variantStyles/image';
import { getImageWithBadgeStyles } from './variantStyles/imageWithBadge';
import { getInitialsStyles } from './variantStyles/initials';
import { getInitialsSelectorStyles } from './variantStyles/initialsSelector';
import { getInitialsWithBadgeStyles } from './variantStyles/initialsWithBadge';
import { getInitialsWithLogoStyles } from './variantStyles/initialsWithLogo';
export const getAvatarProfileStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getEmptyStyles(FOUNDATIONS, FONT),
        ...getEmptyMainSectionStyles(FOUNDATIONS, FONT),
        //
        ...getIconStyles(FOUNDATIONS, FONT),
        ...getIconSelectorStyles(FOUNDATIONS, FONT),
        //
        ...getImageStyles(FOUNDATIONS, FONT),
        ...getImageWithBadgeStyles(FOUNDATIONS, FONT),
        //
        ...getInitialsStyles(FOUNDATIONS, FONT),
        ...getInitialsSelectorStyles(FOUNDATIONS, FONT),
        ...getInitialsWithBadgeStyles(FOUNDATIONS, FONT),
        ...getInitialsWithLogoStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map